(function($) {
	
	var $block = $('.wp-block-metropolis-posts.is-style-carousel');
	
	$block.each( function() {
	
		$(this).addClass('swiper').children('.posts-wrap').addClass('swiper-wrapper').children().addClass('swiper-slide').ready(function () {
			
			const carousel = new Swiper('.wp-block-metropolis-posts.is-style-carousel', {
				
				slidesPerView: 'auto',
				spaceBetween: 24,
    			containerModifierClass: 'carousel-',
				
			});
			
		});
	
	});
	
})(jQuery);